// The candidate summary's route (lane B7 S14, plan §3.4): #requisitions/R-…/debriefs/<cycle>/summary/<application>.
// Registered through the shell's view registry (lane contract C-29); ../register.ts imports this module.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { SummaryPage } from "./SummaryPage";

export const SUMMARY_ROUTE = /^requisitions\/R-\d+\/debriefs\/[^/]+\/summary\/[^/]+$/;

function SummaryRoute({ route }: ViewProps) {
  const [rid = "", , cid = "", , applicationId = ""] = route.parts;
  return createElement(SummaryPage, { rid, cid, applicationId });
}

registerView(SUMMARY_ROUTE, SummaryRoute, { lane: "B7", gates: ["summary.open"] });
